import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SectionConfigModel } from '../../models/section-configuration.model';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AppGroup } from 'src/app/modules/shared/models/section-config.model';
import { Dictionary } from 'src/app/modules/shared/models/dictionary';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { LANGUAGES } from 'src/app/constants';

@Component({
    selector: 'app-groups-configuration',
    templateUrl: './app-groups-configuration.component.html',
    styleUrls: ['./app-groups-configuration.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppGroupsConfigurationComponent implements OnInit {
  @Input() sectionConfig: SectionConfigModel;
  @Input() parentFormGroup: FormGroup;

  expanded: boolean = false;
  forms: FormArray<FormGroup>;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.forms = new FormArray<FormGroup>(this.sectionConfig.appGroups?.map(this.mapAppGroupToControl.bind(this)) ?? []);
    this.parentFormGroup.addControl("appGroups", this.forms);
    this.parentFormGroup.addControl("isEmpty", this.fb.control(this.sectionConfig.isEmpty))
  }

  mapAppGroupToControl(group: AppGroup): FormGroup {
    return this.fb.group({
      names: this.fb.group(this.extendNames(group.names)),
      backgroundColor: this.fb.control(group.backgroundColor),
      appIds: this.fb.array(group.appIds)
    });
  }

  extendNames(names: Dictionary<string>) {
    const result: { [key: string]: FormControl } = {};
    for (let lang of LANGUAGES) {
      result[lang] = this.fb.control(names[lang] ?? "");
    }
    return result;
  }

  addNewGroup(event) {
    event.stopPropagation();
    event.preventDefault();
    const emptyGroup = {
      names: {},
      backgroundColor: '',
      setBackgroundColor: false,
      appIds: []
    };
    this.forms.push(this.mapAppGroupToControl(emptyGroup));

    if (!this.sectionConfig.appGroups) {
      this.sectionConfig.appGroups = []
    }

    this.sectionConfig.appGroups.push(emptyGroup);
  }

  deleteGroup(index) {
    this.sectionConfig.appGroups.splice(index, 1);
    this.forms.removeAt(index);
  }

  moveAppDown(index: number): void {
    this.moveApps(index, index + 1);
  }

  moveAppUp(index: number): void {
    this.moveApps(index, index - 1);
  }

  private moveApps(previousIndex: number, currentIndex: number): void {
    moveItemInArray(this.sectionConfig.appGroups, previousIndex, currentIndex);
    const formArray = this.forms;
    let group = formArray.at(previousIndex);
    formArray.removeAt(previousIndex);
    formArray.insert(currentIndex, group);
  }
}
